import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

class AnimationStartpage {
  constructor() {


    this.startpageWrapper = document.querySelector(".startpage");

    if (!this.startpageWrapper) {
      return;
    }

    this.initAnimations();
    this.initAnimationsSecond();
    this.initHighlightsSliderAnimation();
    this.initTeaserLargeAnimation();
  }

  initAnimationsSecond() {
    gsap.from(".text-second", {
      opacity: 0, y: 100,
      duration: 1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".text-second",
        start: "top bottom",
        toggleActions: "play none none none"
      }
    });
  }

  initAnimations() {
     gsap.from(".text-start", {
       opacity: 0, y: 100,
       duration: 1,
       ease: "power2.out",
       stagger: 0.2,
       scrollTrigger: {
         trigger: ".text-start",
         start: "top bottom",
         toggleActions: "play none none none"
       }
     });
   }

  initHighlightsSliderAnimation() {
    gsap.utils.toArray(".highligts-slider__slider").forEach((slider) => {
      const sliderContainer = slider.closest(".highligts-slider");
      const slides = slider.querySelectorAll(".highligts-slider__slide .highligts-slider-item");
      const nav = sliderContainer?.querySelector(".highligts-slider__nav");

      if (!slides.length) {
        return;
      }

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: slider,
          start: "top 80%",
          toggleActions: "play none none none"
        }
      });

      const slideDuration = 1;
      const slideStagger = 0.2;
      const itemsBeforeNav = Math.min(slides.length, 4);
      const navStartPosition = ((itemsBeforeNav - 1) * slideStagger) + slideDuration;

      timeline.fromTo(slides, {
        opacity: 0,
        y: 100
      }, {
        opacity: 1,
        y: 0,
        duration: slideDuration,
        ease: "power2.out",
        stagger: slideStagger,
        clearProps: "transform,opacity"
      });

      if (nav) {
        timeline.fromTo(nav, {
          opacity: 0,
          y: 100
        }, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          clearProps: "transform,opacity"
        }, navStartPosition);
      }
    });
  }

  initTeaserLargeAnimation() {
    gsap.utils.toArray(".lc-teaser-large .lc-teaser-large__content").forEach((content) => {
      const teaser = content.closest(".lc-teaser-large");
      const image = content.querySelector(".lc-teaser-large__content-image");
      const textContainer = content.querySelector(".lc-teaser-large__content-inner");

      if (!image || !textContainer) {
        return;
      }

      const textItems = Array.from(textContainer.children);
      const isRevert = !!content.closest(".scrollspy-container-wrapper.revert");
      // revert: background from left (-80), image from right (80)
      // normal: background from right (80), image from left (-80)
      const contentXStart = isRevert ? -100 : 100;
      const imageXStart = isRevert ? 100 : -100;

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: content,
          start: "top 80%",
          toggleActions: "play none none none"
        }
      });

      timeline.fromTo(content, {
        x: contentXStart,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 0.9,
        ease: "power2.out",
        clearProps: "transform,opacity"
      });

      timeline.fromTo(image, {
        x: imageXStart,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 0.9,
        ease: "power2.out",
        clearProps: "transform,opacity"
      }, 0.1);

      timeline.fromTo(textItems, {
        opacity: 0,
        y: 40
      }, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power2.out",
        stagger: 0.15,
        clearProps: "transform,opacity"
      }, ">-0.15");
    });
  }
}
export default AnimationStartpage;
